// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tracking-cell {
  min-width: 168px;
}

.tracking-cell__deli {
  max-width: 220px;
  padding: 3px 8px;
  font-size: 12px;
  line-height: 1.25;
  white-space: normal;
}

.tracking-cell__17 {
  text-decoration: none;
}

.tc-chip--transit {
  background: #ecfeff;
  color: #0e7490;
}
`, "",{"version":3,"sources":["webpack://./src/examples/TrackingCell/styles.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".tracking-cell {\n  min-width: 168px;\n}\n\n.tracking-cell__deli {\n  max-width: 220px;\n  padding: 3px 8px;\n  font-size: 12px;\n  line-height: 1.25;\n  white-space: normal;\n}\n\n.tracking-cell__17 {\n  text-decoration: none;\n}\n\n.tc-chip--transit {\n  background: #ecfeff;\n  color: #0e7490;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
